import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { messagePopList, forceReaderingMessageList, messageList, readAllMessage } from '@/api/notice';
const state = {
  popMessageList: [],
  timerInstance: null,
  systemForcePopMessageList: [],
  messageCenterList: [],
  pagination: {
    current: 1,
    pageSize: 10,
    total: 0
  },
  messageCenterTab: 'all',
  unReadCount: 0,
  messageDetailVisible: false,
  forceMessageModelVisible: false,
  hasUnReadMessage: false
};
const mutations = {
  SET_POP_MESSAGE_LIST(state, data) {
    state.popMessageList = data;
  },
  CLEAR_POP_MESSAGE_LIST(state) {
    state.popMessageList = [];
  },
  ADD_POP_MESSAGE_LIST(state, data) {
    state.popMessageList.push(...data);
    sessionStorage.setItem('popMessageList', JSON.stringify(state.popMessageList));
  },
  REMOVE_POP_MESSAGE_LIST(state, id) {
    state.popMessageList.shift();
  },
  SET_TIMER_INSTANCE(state, timer) {
    state.timerInstance = timer;
  },
  CLEAR_TIMER_INSTANCE(state) {
    clearInterval(state.timerInstance);
    state.timerInstance = null;
  },
  SET_SYSTEM_FORCE_POP_MESSAGE_LIST(state, data) {
    state.systemForcePopMessageList = data;
  },
  CLEAR_SYSTEM_FORCE_POP_MESSAGE_LIST(state) {
    state.systemForcePopMessageList = [];
  },
  SET_MESSAGE_CENTER_LIST(state, data) {
    state.messageCenterList = data.map(item => {
      item.content = item.content.replace(/<[^>]+>/g, '');
      return item;
    });
  },
  SET_CURRENT_PAGE(state, data) {
    state.pagination.current = data;
  },
  SET_PAGE_SIZE(state, data) {
    state.pagination.pageSize = data;
  },
  changeMessageCenterTab(state, data) {
    state.messageCenterTab = data;
  },
  SET_UNREAD_COUNT(state, data) {
    state.unReadCount = data;
    state.hasUnReadMessage = data > 0 ? true : false;
  },
  SET_HAS_UNREAD_MESSAGE(state, data) {
    state.hasUnReadMessage = data;
  },
  readAllListMessage(state) {
    state.messageCenterList.forEach(item => {
      item.readingStatus = 1;
    });
  },
  readMessage(state, id) {
    state.messageCenterList.forEach(item => {
      if (item.id === id) {
        item.readingStatus = 1;
      }
    });
  },
  setMessageDetailVisible(state, value) {
    state.messageDetailVisible = value;
  },
  setForceMessageModelVisible(state, value) {
    state.forceMessageModelVisible = value;
  }
};
const actions = {
  getSystemForcePopMessageList({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      forceReaderingMessageList(data).then(res => {
        // res = [
        //   {
        //     id: 1,
        //     title: '标题2',
        //     content:
        //       '内容3<a href=/#/questionnaire/customerManage/questionnaireList/questionModer/ModerIndex/38619>任务列表</a>',
        //     type: 1,
        //     status: 1,
        //     receptionTime: '2020-01-01 00:00:00',
        //     uploadFiles: [
        //       {
        //         name: 't43543.pdf',
        //         url:
        //           'https://test-insurforce.oss-cn-beijing.aliyuncs.com/insurforce/fileTemplate/temp/20240126/16:05:33/12-25.pdf'
        //       }
        //     ]
        //   },
        //   {
        //     id: 2,
        //     title: '标题4',
        //     content: '<p>内容4</p>',
        //     type: 1,
        //     status: 1,
        //     receptionTime: '2020-01-01 00:00:00'
        //   },
        //   {
        //     id: 3,
        //     title: '标7题',
        //     content: '内3容',
        //     type: 1,
        //     status: 1,
        //     receptionTime: '2020-01-01 00:00:00'
        //   },
        //   {
        //     id: 4,
        //     title: '标5题',
        //     content: '内4容',
        //     type: 1,
        //     status: 1,
        //     receptionTime: '2020-01-01 00:00:00'
        //   }
        // ];

        commit('SET_SYSTEM_FORCE_POP_MESSAGE_LIST', res || []);
        resolve();
      }).catch(err => {
        reject(err);
      });
    });
  },
  getPopMessageList({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      messagePopList(data).then(res => {
        commit('SET_POP_MESSAGE_LIST', res);
        resolve();
      }).catch(err => {
        reject(err);
      });
    });
  },
  loopPopMessageList({
    commit,
    state,
    rootState
  }) {
    let timer = null;
    timer = setInterval(() => {
      messagePopList({}).then(res => {
        const userInfo = rootState.user.accountInfo;
        if (!userInfo) {
          // commit('CLEAR_POP_MESSAGE_LIST');
          commit('CLEAR_TIMER_INSTANCE');
        } else {
          // res = [
          //   {
          //     id: 1,
          //     title: '标题2',
          //     content:
          //       '<a class="variable-message-class" href=/#/policy/homeManage/policyInfo/38967>任务列表</a><b>内容3fjdfsdkfsdkffffffffffffffffffffffffffffffffffffffffffffff</b>',
          //     type: 1,
          //     status: 1,
          //     receptionTime: '2020-01-01 00:00:00'
          //   },
          //   {
          //     id: 2,
          //     title: '标题4',
          //     content: '<i>内容4</i>',
          //     type: 1,
          //     status: 1,
          //     receptionTime: '2020-01-01 00:00:00'
          //   },
          //   {
          //     id: 3,
          //     title: '标7题',
          //     content: '<i>内3容</i>',
          //     type: 1,
          //     status: 1,
          //     receptionTime: '2020-01-01 00:00:00'
          //   },
          //   {
          //     id: 4,
          //     title: '标5题',
          //     content: '内4容',
          //     type: 1,
          //     status: 1,
          //     receptionTime: '2020-01-01 00:00:00'
          //   },
          //   {
          //     id: 6,
          //     title: '标5题',
          //     content: '内4容',
          //     type: 6,
          //     status: 1,
          //     receptionTime: '2020-01-01 00:00:00'
          //   },
          //   {
          //     id: 7,
          //     title: '标5题',
          //     content: '内4容',
          //     type: 6,
          //     status: 1,
          //     receptionTime: '2020-01-01 00:00:00'
          //   }
          // ];
          if (res && res.length > 0) {
            commit('SET_HAS_UNREAD_MESSAGE', true);
          }
          commit('ADD_POP_MESSAGE_LIST', res || []);
        }
      });
    }, 1000 * 5);
    commit('SET_TIMER_INSTANCE', timer);
  },
  getMessageCenterList({
    commit,
    state
  }) {
    let params = {
      page: state.pagination.current,
      pageSize: state.pagination.pageSize
    };
    if (state.messageCenterTab === 'unRead') {
      params.readingStatus = 0;
    }
    return new Promise((resolve, reject) => {
      messageList(params).then(res => {
        commit('SET_MESSAGE_CENTER_LIST', res.items || []);
        state.pagination.total = res.totalNum;
        if (state.messageCenterTab === 'unRead') {
          commit('SET_UNREAD_COUNT', res.totalNum);
        }
        resolve();
      }).catch(err => {
        reject(err);
      });
    });
  },
  getUnReadCount({
    commit
  }) {
    return new Promise((resolve, reject) => {
      messageList({
        readingStatus: 0,
        page: 1,
        pageSize: 1
      }).then(res => {
        commit('SET_UNREAD_COUNT', res.totalNum);
        resolve();
      }).catch(err => {
        reject(err);
      });
    });
  },
  readAll({
    commit,
    dispatch
  }) {
    return new Promise((resolve, reject) => {
      readAllMessage({}).then(res => {
        if (res) {
          commit('SET_UNREAD_COUNT', 0);
          commit('readAllListMessage');
          // dispatch('getMessageCenterList');
        }
      }).catch(err => {
        reject(err);
      });
    });
  }
};
export default {
  namespaced: true,
  state,
  mutations,
  actions
};